import Vue from 'vue'

export function getIconFromFileType(fileType: string) {
    let icons = (<any>Vue.prototype).$icons;

    switch (fileType) {
        case 'application/pdf':
        case 'application/pdx':
        case 'application/pdfxml':
        case 'application/vnd.fdf':
            return icons.FILE_PDF
        case 'image/png':
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/jpe':
        case 'image/jfif':
        case 'image/tif':
        case 'image/tiff':
        case 'image/bmp':
        case 'image/gif':
        case 'image/x-tga':
            return icons.FILE_IMAGE
        case 'application/msword':
        case 'application/rtf':
            return icons.FILE_WORD;
        case 'text/csv':
        case 'application/vnd.ms-excel': // Excel 2005
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': // Excel 2007
            return icons.FILE_EXCEL;
        case 'application/vnd.ms-powerpoint':
            return icons.FILE_PPT;
        case 'application/zip':
        case 'application/x-rar-compressed':
        case 'application/x-7z-compressed':
        case 'application/x-bzip2':
        case 'application/x-gzip':
        case 'application/x-tar':
        case 'application/wim':
        case 'application/x-xz':
            return icons.FILE_ZIP;
        case 'text/plain':
        case 'text/log':
        case 'text/ini':
        case 'text/css':
            return icons.FILE_TXT;
        default:
            return icons.FILE_UNKNOWN;
    }
}
